module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMiIgaGVpZ2h0PSIxNCIgdmlld0JveD0iMCAwIDIyIDE0Ij4KICA8cG9seWdvbiBmaWxsPSIjMDAwMDAwIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHBvaW50cz0iNzE5LjYwNyA5MjkuMjEzIDcwOSA5MTguNjA3IDcxMC43MiA5MTYuODg3IDcxOS42MDcgOTI1Ljc3MyA3MjguNDkzIDkxNi44ODcgNzMwLjIxMyA5MTguNjA3IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNzA5IC05MTYpIi8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/img/arrow.svg
// module id = 609
// module chunks = 168707334958949